/* Journ-E header search (v14). Markup: snippets/search-modal.liquid. Results: sections/predictive-search.liquid
   via Shopify's Section Rendering API. No dependencies; loaded with defer from sections/header.liquid.
   Combobox pattern: focus stays in the input, arrow keys move aria-activedescendant through [role=option]. */
(function () {
  'use strict';
  var dlg = document.getElementById('SearchModal');
  if (!dlg || typeof dlg.showModal !== 'function') return; // the header icon stays a plain link to /search

  var form = dlg.querySelector('[data-ps-form]');
  var input = form.querySelector('input[name="q"]');
  var list = document.getElementById('SearchModalList');
  var emptyBox = dlg.querySelector('[data-ps-empty]');
  var live = dlg.querySelector('[data-ps-live]');
  var status = dlg.querySelector('[data-ps-status]');
  var recentGroup = dlg.querySelector('[data-ps-recent]');
  var recentRow = dlg.querySelector('[data-ps-recent-list]');
  var SUGGEST = dlg.getAttribute('data-suggest-url') || '/search/suggest';
  var PARAMS = '&section_id=predictive-search&resources[type]=product,collection,article,page' +
    '&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
  var KEY = 'journe:recent-searches';
  var cache = {}, timer, ctrl, active = -1;

  /* ---------- recent searches (this browser only) ---------- */
  function readRecent() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function saveRecent(q) {
    q = (q || '').trim();
    if (!q) return;
    var r = readRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    r.unshift(q);
    try { localStorage.setItem(KEY, JSON.stringify(r.slice(0, 5))); } catch (e) {}
  }
  function searchUrl(q) { return form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
  function renderRecent() {
    var r = readRecent();
    recentRow.textContent = '';
    r.forEach(function (q, i) {
      var a = document.createElement('a');
      a.className = 'sq-chip sq-chip--recent';
      a.href = searchUrl(q);
      a.id = 'sq-r' + i;
      a.tabIndex = -1;
      a.setAttribute('role', 'option');
      a.setAttribute('aria-selected', 'false');
      a.textContent = q;
      recentRow.appendChild(a);
    });
    recentGroup.hidden = !r.length;
  }

  /* ---------- active option ---------- */
  function options() {
    return Array.prototype.filter.call(list.querySelectorAll('[role="option"]'), function (o) { return !o.closest('[hidden]'); });
  }
  function clearActive() {
    active = -1;
    input.removeAttribute('aria-activedescendant');
    list.querySelectorAll('[aria-selected="true"]').forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
  }
  function move(dir) {
    var opts = options(), n = opts.length;
    if (!n) return;
    var next = active < 0 ? (dir > 0 ? 0 : n - 1) : (active + dir + n) % n;
    clearActive();
    active = next;
    opts[active].setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', opts[active].id);
    opts[active].scrollIntoView({ block: 'nearest' });
  }

  /* ---------- results ---------- */
  function paint(q, html) {
    if (input.value.trim() !== q) return; // a newer keystroke owns the list
    clearActive();
    emptyBox.hidden = true;
    live.hidden = false;
    if (html) {
      live.innerHTML = html;
    } else { // request failed: still offer the full search
      live.textContent = '';
      var a = document.createElement('a');
      a.className = 'ps__all'; a.id = 'ps-all'; a.tabIndex = -1; a.href = searchUrl(q);
      a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false');
      a.textContent = 'See all results for "' + q + '"';
      live.appendChild(a);
    }
    var n = live.querySelectorAll('[data-ps-hit]').length;
    status.textContent = n ? n + (n === 1 ? ' suggestion' : ' suggestions') + ', use the arrow keys to choose' : 'No quick matches, press Enter to search everything';
  }
  function show(q) {
    if (!q) {
      if (ctrl) ctrl.abort();
      clearActive();
      live.hidden = true;
      emptyBox.hidden = false;
      renderRecent();
      status.textContent = '';
      return;
    }
    if (cache[q] !== undefined) return paint(q, cache[q]);
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    list.setAttribute('aria-busy', 'true');
    fetch(SUGGEST + '?q=' + encodeURIComponent(q) + PARAMS, { signal: ctrl.signal, headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        var sec = new DOMParser().parseFromString(t, 'text/html').getElementById('shopify-section-predictive-search');
        cache[q] = sec ? sec.innerHTML.trim() : '';
        paint(q, cache[q]);
      })
      .catch(function (e) { if (e.name !== 'AbortError') paint(q, ''); })
      .then(function () { list.removeAttribute('aria-busy'); });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(function () { show(input.value.trim()); }, 180);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      move(e.key === 'ArrowDown' ? 1 : -1);
    } else if (e.key === 'Escape') { // Chromium spends Esc on clearing a type=search box; close in one press
      e.preventDefault();
      dlg.close();
    } else if (e.key === 'Enter' && active > -1) {
      var o = options()[active];
      if (o) { e.preventDefault(); saveRecent(input.value); o.click(); }
    }
  });
  form.addEventListener('submit', function (e) {
    if (!input.value.trim()) { e.preventDefault(); input.focus(); return; }
    saveRecent(input.value);
  });
  list.addEventListener('click', function (e) {
    if (e.target.closest('[role="option"]')) saveRecent(input.value);
  });
  list.addEventListener('mousemove', function (e) { // keep mouse and keyboard on the same highlight
    var o = e.target.closest('[role="option"]');
    if (!o || o.getAttribute('aria-selected') === 'true') return;
    var i = options().indexOf(o);
    if (i > -1) { active = i - 1; move(1); }
  });

  /* ---------- open / close ---------- */
  function setExpanded(v) {
    document.querySelectorAll('[data-search-open]').forEach(function (t) { t.setAttribute('aria-expanded', v ? 'true' : 'false'); });
  }
  function open(e) {
    if (e) e.preventDefault();
    if (dlg.open) return;
    dlg.showModal();
    setExpanded(true);
    input.focus();
    if (input.value) { input.select(); show(input.value.trim()); } else { show(''); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-search-open]');
    if (t && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) open(e); // modified click: /search in a new tab
  });
  document.addEventListener('keydown', function (e) { // "/" opens search, as on most stores
    var el = document.activeElement;
    if (e.key === '/' && !dlg.open && !(el && (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) || el.isContentEditable))) open(e);
  });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); }); // backdrop
  dlg.querySelector('[data-ps-close]').addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('close', function () { setExpanded(false); clearActive(); });
  setExpanded(false);
})();
